import { fetchData } from '../../../helpers/base_data_fetcher';

export default {
  getPhotos: () => fetchData('page.photos'),
  getSite: () => fetchData('site'),
  getCustomer: () => fetchData('customer'),
  getFormValues: () => fetchData('page.post_ad_form'),
  getSession: () => fetchData('session'),
  getErrors: () => fetchData('page.errors'),
  getExperiments: () => fetchData('experiments'),
  getPage: () => fetchData('page'),
  getLocalisations: () => fetchData('localisations')
};
